module.exports = __webpack_public_path__ + "static/p04_nota05-5461cf894d59e3064caf1225f05301a8.png";